import { useState } from "react";

import { HostResponseCodeEditForm } from "src/app/features/HostResponseCode/components/forms/HostResponseCodeEditForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { BackButton } from "../../../../components/FeatureButtons/BackButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";

export const HostResponseCodeEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const hasWriteAccess = canAccess(ResourceName.HOST_RESPONSE_CODE, "canWrite");

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.hostResponseCodeEditFormPage" />
                <ActionBar>
                    <SubmitButton isDisabled={!hasWriteAccess} onClick={triggerFormSubmit} />
                    <BackButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.HOST_RESPONSE_CODE}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <HostResponseCodeEditForm runSubmit={runSubmit} />
            </FPageContent>
        </FPage>
    );
};
